// export default OrgNode;
import React from "react";

function OrgNode({ data, gradient }) {
  return (
    <div className={`org-node ${gradient || ""}`}>
      <div className="img-wrapper">
        <img src={data.image} alt={data.name} className="org-image" />
      </div>
      <h4 className="node-name">{data.name}</h4>
      <p className="node-role">{data.role}</p>
      {data.desc && <p className="node-desc">{data.desc}</p>}
    </div>
  );
}

export default OrgNode;